/**
 * @desc filters统一导出，导入文件
 * @todo 默认内置filters
 */
import Vue from 'vue';

import vehicleBrandAndSerial from './vehicleBrandAndSerial';
import fieldVaild from './fieldVaild';
import dateFormat from './dateFormat';
import saleAndservice from './saleAndservice';
import couponValidTime from './couponValidTime';
import couponAuditStatus from './couponAuditStatus';
import couponStatus from './couponStatus';
import formatMoney from './formatMoney';
import handleParameter from './handleParameter';
import repairStatus from './repairStatus';
import nameAndPhone from './nameAndPhone';
import photoTip from './photoTip';
import notRepairTypes from './notRepairTypes';
import equityTypeFilter from './equityTypeFilter';
import subsidySettleType from './subsidySettleType';
import subsidySettleWay from './subsidySettleWay';
import formatNumber from './formatNumber';
import workOrderStatus from './workOrderStatus';
import workOrderSource from './workOrderSource';
import amountFormat from './amountFormat';
import packageStatus from './packageStatus';
import bindStatus from './bindStatus';
import usedCarVehicleBrandAndSerial from '@/filters/usedCarVehicleBrandAndSerial';

// 需要全局注册的filter
const globalFilters = {
    vehicleBrandAndSerial,
    usedCarVehicleBrandAndSerial,
    fieldVaild,
    dateFormat,
    formatMoney,
    handleParameter,
    amountFormat,
    bindStatus,
};
Object.keys(globalFilters).forEach(k => Vue.filter(k, globalFilters[k]));

export {
    vehicleBrandAndSerial,
    fieldVaild,
    dateFormat,
    saleAndservice,
    couponValidTime,
    couponAuditStatus,
    couponStatus,
    formatMoney,
    handleParameter,
    repairStatus,
    nameAndPhone,
    photoTip,
    notRepairTypes,
    equityTypeFilter,
    subsidySettleType,
    subsidySettleWay,
    formatNumber,
    workOrderStatus,
    workOrderSource,
    amountFormat,
    packageStatus,
    bindStatus,
};
